// import Vue from 'vue'
// import VueRouter from 'vue-router'
// import Router from 'vue-router'

import router from "./../router"

import axios from 'axios';
import Vue from "vue";
if (process.env.VUE_APP_API)
    axios.defaults.baseURL = process.env.VUE_APP_API;
else
    axios.defaults.baseURL = 'http://cyancoder.ir:8001/';
// axios.defaults.baseURL = Vue.prototype.$API;

// if(!window.location.href.includes("login")){
//    axios.defaults.headers.common['Authorization'] = 'bearer ' + localStorage.getItem('token');
// }
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';


export default axios;